var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPeople = function SvgPeople(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.096,13.929c2.594,0,4.404,1.38,4.404,3.355v0.559h-8.808v-0.56C11.692,15.309,13.503,13.929,16.096,13.929 L16.096,13.929z M11.622,8.906c0,1.516-1.214,2.75-2.707,2.75c-1.493,0-2.707-1.235-2.707-2.75s1.214-2.75,2.707-2.75 S11.622,7.39,11.622,8.906z M18.297,10.574c0,1.234-0.988,2.237-2.203,2.237s-2.203-1.004-2.203-2.237s0.988-2.237,2.203-2.237 C17.31,8.338,18.297,9.342,18.297,10.574z M11.926,13.646c-1.109,0.866-1.785,2.123-1.785,3.639v0.559H3.5v-0.687 c0-2.429,2.227-4.126,5.415-4.126C10.063,13.032,11.086,13.252,11.926,13.646L11.926,13.646z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeople, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/people.403261a8.svg";
export { ForwardRef as ReactComponent };